import { useTranslation } from 'react-i18next';
import { SLIDE_IDS, BROWSER_STORAGE_KEYS } from '@constants';
import { getBrowserStorageItem } from './browserStorage';

export function getDTIRangeAndColor(DTICategory) {
    const { t } = useTranslation();

    switch(DTICategory) {
        case 'low':
            return { DTIRange: t('dti.range_low'), backgroundColor: '#D2FFD1'};
        case 'medium':
            return { DTIRange: t('dti.range_medium'), backgroundColor: '#F9E534'};
        case 'high':
            return { DTIRange: t('dti.range_high'), backgroundColor: '#FFE0E0'};
        default:
            return `DTI category ${DTICategory} not recognized`;
    }
}

/* This is just a utility that helps us parse through the shape of the slide details and 
   obtain only the numerical keys (which represent terms)

  I will add a test case in the future */

export function getAvailableTerms(slideId, details) {
    const { termOptions } = SLIDE_IDS;

    const keys = slideId == termOptions ? Object.keys(details).filter(key => !!parseInt(key)) : Object.keys(details.proposedSituations);
    const availableTerms = keys.map(key => parseInt(key)); 
    
    return availableTerms;
}

function populateLoginFieldsFromQueryParams(search, loginInfo, setLoginInfo) {
    const creditAnalysisData = new URLSearchParams(search);

    const leadId = creditAnalysisData.get('leadid');
    const email = creditAnalysisData.get('email');

    if (leadId && email) {
        setLoginInfo({...loginInfo, leadId: parseInt(leadId), email });
    } else if (leadId && !email) {
        setLoginInfo({...loginInfo, leadId: parseInt(leadId) });
    } else if (!leadId && email) {
        setLoginInfo({...loginInfo, email });
    }
}  

export function checkForCreditAnalysisQueryParams(search, loginInfo, setLoginInfo) {
    const { queryParamsKey } = BROWSER_STORAGE_KEYS;
        
    const stashedSearchBeforeOAuth = getBrowserStorageItem(queryParamsKey, sessionStorage);

    if (search) {
        populateLoginFieldsFromQueryParams(search, loginInfo, setLoginInfo);
    } else if (!search && stashedSearchBeforeOAuth) {
        populateLoginFieldsFromQueryParams(stashedSearchBeforeOAuth, loginInfo, setLoginInfo);
    } else {
        console.log('Couldn\'t find any saved query params. Login fields will be blank');
    }
}
